import {
  DashedRoad,
  GroundShadow,
  HorizontalFadeMask,
  LoaderSvg,
  type VehicleLoaderProps,
  useSvgId,
} from "../loader-svg-parts";
import { VehicleOutline } from "../vehicle-outline";

const SPEED_LINES = [
  { y: 33, x: -2, length: 9, delay: 0 },
  { y: 39.5, x: -8, length: 14, delay: 0.3 },
  { y: 46, x: -4, length: 10, delay: 0.6 },
];

export function VehicleLoaderRoad({ className }: VehicleLoaderProps) {
  const maskId = useSvgId("vehicle-loader-road-mask");

  return (
    <LoaderSvg viewBox="-16 18 96 40" modifiers="vehicle-loader-driving" className={className}>
      <HorizontalFadeMask id={maskId} x={-16} y={18} width={96} height={40} />
      <GroundShadow />
      <g mask={`url(#${maskId})`}>
        <DashedRoad x1={-16} x2={80} />
        <g strokeLinecap="round" className="stroke-primary/50">
          {SPEED_LINES.map(({ x, y, length, delay }) => (
            <line
              key={y}
              x1={x}
              x2={x + length}
              y1={y}
              y2={y}
              strokeWidth={1.5}
              className="vehicle-loader-streak"
              style={{ animationDelay: `${delay}s` }}
            />
          ))}
        </g>
      </g>
      <VehicleOutline />
    </LoaderSvg>
  );
}
